import './cart.css';
import React from 'react';

function Cart() {
    return (
        <>
            <div className="cardapio-entrada">
                <h1 id="topico">Entradas</h1>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E01-Croquete de Bacalhau  </h2>
                    <p className="card-description">(10 unidades) serve 2P</p>
                    <h2 className="valor">R$: 40,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E02-Burrata</h2>
                    <p className="card-description">(queijo de búfala, torradas e tomates confitados) Serve 2P</p>
                    <h2 className="valor">R$: 52,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E03-Cesto de Salada de Parmesão com Mix de Folhas</h2>
                    <p className="card-description">Serve 2p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E04-Salada Italiana com cubos de frango</h2>
                    <p className="card-description">Serve 2p</p>
                    <h2 className="valor">R$: 28,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E05-Tabua Adega</h2>
                    <p className="card-description">(queijo, azeitona, salame e torradinhas) Serve 2p</p>
                    <h2 className="valor">R$: 45,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E06-Tabua Quatro Queijos Adega</h2>
                    <p className="card-description">(provolone,nozinho, parmesão e gouda) Serve 2p</p>
                    <h2 className="valor">R$: 55,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E07-Tábua Provolera</h2>
                    <p className="card-description">(provolone na pedra com orégano) Serve 2p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E08-Salada Caprese</h2>
                    <p className="card-description">(tomates cereja ao azeite,manjericão e queijo bolinha) Serve 2p</p>
                    <h2 className="valor">R$: 30,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E09-Trio de Bruschettas</h2>
                    <p className="card-description">(alho poró – cogumelos – tomates cereja) Serve 2p</p>
                    <h2 className="valor">R$: 35,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E10-Brie com Mel</h2>
                    <p className="card-description">(queijo brie, mel, castanhas e torradinhas) Serve 2p</p>
                    <h2 className="valor">R$: 58,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E11-Chapa Adega</h2>
                    <p className="card-description">(picanha grelhada, tomate cereja e queijo provolone) Serve 2p</p>
                    <h2 className="valor">R$: 110,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E12-Ostras Gratinadas</h2>
                    <p className="card-description">(08 unidades) Serve 2p</p>
                    <h2 className="valor">R$: 66,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E13-Bolinho de Carne seca </h2>
                    <p className="card-description">(08 unidades) Serve 2p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>


            <div className="cardapio-entrada">
                <h1 id="topico">Pratos</h1>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P01-Prime Rib com Risoto de Brócolis e Tomates </h2>
                    <p className="card-description">Serve 2p</p>
                    <h2 className="valor">R$: 115,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P02-Fettuccine com Tomates, Manjericão, Mignon Grelhado ao Molho Gorgonzola </h2>
                    <p className="card-description">Serve 2p</p>
                    <h2 className="valor">R$: 110,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P03-Lasanha de Carne Desfiada </h2>
                    <p className="card-description">Serve 2p</p>
                    <h2 className="valor">R$: 69,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P04-Lasanha Quatro Queijos </h2>
                    <p className="card-description"> Serve 2p</p>
                    <h2 className="valor">R$: 69,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P05-Spaghetti Aglio e Oli, com Beff Ancho grelhado </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P06-Fettuccine Al Mare </h2>
                    <p className="card-description">(lula, camarão, mariscos e azeite provençal) Serve 1p</p>
                    <h2 className="valor">R$: 90,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P07-Fettuccine com Nata e Salmão </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 70,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P08-Ossobuco com Polenta cremosa </h2>
                    <p className="card-description">(08 unidades) Serve 1p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P09-Risotto al Porro e Mignon na mostarda dijon </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 69,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P10-Risotto Zucchini e Parmesão  </h2>
                    <p className="card-description">(abobrinha) Serve 1p</p>
                    <h2 className="valor">R$: 59,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P11-Risotto de Maça Verde com Carré de Cordeiro grelhado </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E13-Bolinho de Carne seca </h2>
                    <p className="card-description">(08 unidades) Serve 2p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P12-Risotto al Funghi com Cubos de Mignon </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 69,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P13-Risotto de Gorgonzola e Entrecôte grelhado </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 69,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P14-Risotto alla Milanesa com agu de cordeiro </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 70,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P15-Risotto Mare e Monti  </h2>
                    <p className="card-description">(bacon, camarão, champignon e vinho branco) Serve 2p</p>
                    <h2 className="valor">R$: 75,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> E16-Risotto al Limão Siciliano c/Salmão Grellhado </h2>
                    <p className="card-description">Serve 1p</p>
                    <h2 className="valor">R$: 75,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P17- Ravióli de Ricota e Cogumelo  </h2>
                    <p className="card-description">(Vinho branco e bacon)Serve 1p</p>
                    <h2 className="valor">R$: 70,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P18-Prato Kids  </h2>
                    <p className="card-description">(Penne, mignon em cubos e fritas) Serve 1p</p>
                    <h2 className="valor">R$: 45,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P19-Adicional de Beef Ancho </h2>
                    <p className="card-description">1 unidade</p>
                    <h2 className="valor">R$: 20,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P20-Adicional de Medalhão de Mignon </h2>
                    <p className="card-description">1 uniadde</p>
                    <h2 className="valor">R$: 20,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> P21-Adicional de Posta Salmão</h2>
                    <p className="card-description">1 uniadde</p>
                    <h2 className="valor">R$: 20,00 </h2>
                </div>
            </div>


            <div className="cardapio-entrada">
                <h1 id="topico">Calzones</h1>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> C01-Calzone Parisiense </h2>
                    <p className="card-description">(Molho de tomate, presunto, frango desfiado, requeijão, ervilha e mussarela) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'> C02-Calzone do Chefe </h2>
                    <p className="card-description">(Molho de tomate, calabresa, azeitonas, palmito e mussarela) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>C03-Strogonoff de Mignon  </h2>
                    <p className="card-description">(Molho de tomate, Mignon em tiras, mussarela e parmesão) Serve 2p</p>
                    <h2 className="valor">R$: 70,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>C04-Calzone de Calabresa  </h2>
                    <p className="card-description"> (Molho de tomate, calabresa, bacon e mussarela) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>C05-Calzone a Jardineira </h2>
                    <p className="card-description">(Molho de tomate, palmito, brócolis, ervilha, tomates em cubo, catupiry e mussarela) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>C06-Calzone Prestígio </h2>
                    <p className="card-description">(Leite condensado, chocolate e coco ralado e mussarela) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>


            <div className="cardapio-entrada">
                <h1 id="topico">Pizzas</h1>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>Z01-Zucchini  </h2>
                    <p className="card-description">(Muçarela, molho, abobrinha e queijo parmesão) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>Z02-Caprese </h2>
                    <p className="card-description">(Muçarela, molho, Tomate,Pesto de azeitona preta, queijo de búfala) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>Z03-Margherita</h2>
                    <p className="card-description"> (Muçarela, molho, tomate, manjericão)  Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>Z04-Parma e Rúcula </h2>
                    <p className="card-description">(Muçarela, molho, tomate seco, presunto e rúcula) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>Z05-Salame Milano </h2>
                    <p className="card-description"> (Muçarela, molho e salame milano) Serve 2p</p>
                    <h2 className="valor">R$: 65,00 </h2>
                </div>
            </div>


            <div className="cardapio-entrada">
                <h1 id="topico">Sobremesas</h1>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>S01-Grand Gateau </h2>
                    <p className="card-description">(Morangos, sorvete chocolate Branco ou Preto e castanhas) Serve 1p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>S02-Panna Cotta  </h2>
                    <p className="card-description">(Leite cozido com calda de frutas vermelhas) Serve 2p</p>
                    <h2 className="valor">R$: 23,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>S03-Verrine de Gianduia  </h2>
                    <p className="card-description"> (Duas camadas de chocolate com nutella e avelã) Serve 1p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>S04-Apfelstrudel </h2>
                    <p className="card-description">(torta de maça e sorvete de creme) Serve 2p</p>
                    <h2 className="valor">R$: 26,00 </h2>
                </div>
            </div>

            <div className="cardapio">
                <div id="item-cardapio">
                    <h2 className='cardapio-titulo'>S05-Diamante Chocolate  </h2>
                    <p className="card-description">(Chocolate recheado com cream cheese, castanhas e doce de leite) Serve 1p</p>
                    <h2 className="valor">R$: 32,00 </h2>
                </div>
            </div>
            <div className="cardapio-entrada">
          <h1 id="topico">Espumantes</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Aurora Moscatel Branco </h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Aurora Moscatel Rose </h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Aurora Brut Branco </h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Garibaldi Moscatel Branco </h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Garibaldi Moscatel Rosé </h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Garibaldi Pró Seco</h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 42,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Primícias Moscatel Branco</h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 27,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Primícias Moscatel Rosé</h2>
          <p className="card-description"> BRASIL</p>
          <h2 className="valor">R$: 27,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">Vinhos Branco</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Vinho Verde Leira  </h2>
          <p className="card-description"> PORTUGAL</p>
          <h2 className="valor">R$: 65,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Quinta de Bons Ventos   </h2>
          <p className="card-description">PORTUGAL</p>
          <h2 className="valor">R$: 65,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Vinho Verde Levity </h2>
          <p className="card-description"> PORTUGAL</p>
          <h2 className="valor">R$: 58,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Vinho Olaria Suave </h2>
          <p className="card-description"> PORTUGAL</p>
          <h2 className="valor">R$: 36,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Wave Bianco</h2>
          <p className="card-description"> ITÁLIA</p>
          <h2 className="valor">R$: 55,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">VINHOS ROSÉ</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Sutter Home (White Zinfandel) </h2>
          <p className="card-description"> EUA</p>
          <h2 className="valor">R$: 95,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Wave Rosato</h2>
          <p className="card-description">ITÁLIA</p>
          <h2 className="valor">R$: 55,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Vinho Verde Levity </h2>
          <p className="card-description"> PORTUGAL</p>
          <h2 className="valor">R$: 58,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Quinta de Bons Ventos</h2>
          <p className="card-description"> PORTUGAL</p>
          <h2 className="valor">R$: 65,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">VINHOS TINTO</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Alma Negra Misterio</h2>
          <p className="card-description"> ARGENTINA</p>
          <h2 className="valor">R$: 180,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>La Linda (Malbec)</h2>
          <p className="card-description"> ARGENTINA</p>
          <h2 className="valor">R$: 76,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>La Linda (Cabernet Sauvignon)</h2>
          <p className="card-description"> ARGENTINA</p>
          <h2 className="valor">R$: 76,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>La Linda (Cabernet Sauvignon)</h2>
          <p className="card-description"> ARGENTINA</p>
          <h2 className="valor">R$: 76,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>DV Catena (Cabernet/Malbec)</h2>
          <p className="card-description"> ARGENTINA</p>
          <h2 className="valor">R$: 170,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Fin Del Mundo (Pinot Noir)</h2>
          <p className="card-description"> ARGENTINO</p>
          <h2 className="valor">R$: 80,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Los Haroldos (Malbec)</h2>
          <p className="card-description"> ARGENTINO</p>
          <h2 className="valor">R$: 85,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Yellow Tail (Shiraz)</h2>
          <p className="card-description"> AUSTRÁLIA</p>
          <h2 className="valor">R$: 85,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Casillero Del Diablo (Carménère)</h2>
          <p className="card-description">CHILE</p>
          <h2 className="valor">R$: 68,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Casillero Del Diablo (Merlot)</h2>
          <p className="card-description">CHILE</p>
          <h2 className="valor">R$: 68,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Victorium III Gran Sellecion 3 anos (Tempranillo)</h2>
          <p className="card-description">ESPANHA</p>
          <h2 className="valor">R$: 89,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Calvet 1818</h2>
          <p className="card-description">FRANÇA</p>
          <h2 className="valor">R$: 60,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Calvet (Pinot Noir)</h2>
          <p className="card-description">FRANÇA</p>
          <h2 className="valor">R$: 68,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Wave Rosso</h2>
          <p className="card-description">ITÁLIA</p>
          <h2 className="valor">R$: 55,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Wave Rosso</h2>
          <p className="card-description">ITÁLIA</p>
          <h2 className="valor">R$: 55,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Barricado (Alicante Bouschet, Aragonês, Touriga Nacional, Trincadeira)</h2>
          <p className="card-description">PORTUGAL</p>
          <h2 className="valor">R$: 58,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Quinta de Bons Ventos (Castelão, Camarate, Tinta Miúda e Touriga Nacional)</h2>
          <p className="card-description">PORTUGAL</p>
          <h2 className="valor">R$: 65,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Lacertilia (Tannat)</h2>
          <p className="card-description">URUGUAI</p>
          <h2 className="valor">R$: 74,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Lyngrove Pinotage</h2>
          <p className="card-description">ÁFRICA DO SUL</p>
          <h2 className="valor">R$: 100,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Sutter Home (Cabernet Sauvignon)</h2>
          <p className="card-description">CALIFORNIA</p>
          <h2 className="valor">R$: 95,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Taça Vinho Viecelli</h2>
          <p className="card-description">BRASIL</p>
          <h2 className="valor">R$: 7,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">BEBIDAS NÃO ALCOÓLICAS</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Água Mineral Sem Gás</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 4,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Água Mineral Com Gás</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 4,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Água Tônica Schweppes Lata</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 5,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Suco de Uva Integral</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 6,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Suco de Laranja Natural</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 6,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Refrigerante Lata Coca-Cola</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 5,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Refrigerante Lata Coca-Cola Zero</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 5,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Refrigerante Lata Fanta Laranja</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 5,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Refrigerante Lata Sprite</h2>
          <p className="card-description"></p>
          <h2 className="valor">R$: 5,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">BEBIDAS ALCOÓLICAS</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Eisenbahn Pilsen </h2>
          <p className="card-description">Long Neck</p>
          <h2 className="valor">R$: 7,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Patagônia</h2>
          <p className="card-description"> (Bohemian Pilsener) 740ml</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Patagônia </h2>
          <p className="card-description">(Amber Lager) 740ml</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Patagônia </h2>
          <p className="card-description">(Weisse) 740ml</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Spaten </h2>
          <p className="card-description">Lager 600 ml</p>
          <h2 className="valor">R$: 12,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Stella Artois </h2>
          <p className="card-description">Lager 600 ml</p>
          <h2 className="valor">R$: 14,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Cerveja Corona Extra   </h2>
          <p className="card-description">Pilsen Long Neck 330 ml</p>
          <h2 className="valor">R$: 9,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Campari</h2>
          <p className="card-description">(Dose)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Whisky Jack Daniel’s  </h2>
          <p className="card-description">(Dose)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Gin </h2>
          <p className="card-description">(Dose)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio-entrada">
          <h1 id="topico">DRINKS ALCOÓLICOS</h1>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Gin Tônica </h2>
          <p className="card-description">(Gin, especiarias e água tônica)</p>
          <h2 className="valor">R$: 18,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Gin Soda </h2>
          <p className="card-description">(Gin, Soda Limonada ou Sprite)</p>
          <h2 className="valor">R$: 18,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Campari Tônica </h2>
          <p className="card-description">(Campari e água tônica)</p>
          <h2 className="valor">R$: 18,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Gin Tônica Morango </h2>
          <p className="card-description">(Gin, água tônica e morangos)</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Mojito </h2>
          <p className="card-description">(Run, hortelã, suco de limão, soda ou água com gás)</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Negroni  </h2>
          <p className="card-description">(Campari, gin, vermute e laranja)</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Jack n’ Coke</h2>
          <p className="card-description"> (Jack Daniels com coca-cola)</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Aperol Spritz </h2>
          <p className="card-description">(Aperol, espumante brut, água com gás e laranja)</p>
          <h2 className="valor">R$: 22,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Summer Apple </h2>
          <p className="card-description"> (Gin, licor de maçã, suco de laranja, água tônica)</p>
          <h2 className="valor">R$: 26,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Caipira </h2>
          <p className="card-description">(Cachaça Ypioca ou Velho Barreiro, limão, açúcar e gelo)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Caipiroska </h2>
          <p className="card-description">(Vodka Smirnoff, limão, açúcar e gelo)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Caipironita </h2>
          <p className="card-description">(Cachaça Ypioca ou Velho Barreiro, limão, açúcar, Coronita e gelo) </p>
          <h2 className="valor">R$: 22,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Hi-fi </h2>
          <p className="card-description">(2 doses Vodka com Suco de Laranja ou Refrigerante de Laranja)</p>
          <h2 className="valor">R$: 15,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Gin Tônica de Abacaxi  </h2>
          <p className="card-description">(Gin, suco abacaxi, água tônica)</p>
          <h2 className="valor">R$: 20,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>New York Sour </h2>
          <p className="card-description">(Vinho tinto,Whisky, Xarope de açucar e limão siciliano)</p>
          <h2 className="valor">R$: 26,00 </h2>
        </div>
        </div>

        <div className="cardapio">
        <div id="item-cardapio">
          <h2 className='cardapio-titulo'>Moscow Mule </h2>
          <p className="card-description">(Vodka, Monin de gengibre, limão, espuma de gengibre e gelo)</p>
          <h2 className="valor">R$: 25,00 </h2>
        </div>
        </div>
        </>
    );
}

export default Cart;